var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            "close-on-press-escape": true,
            wrapperClosable: true,
            size: "90%",
            "before-close": _vm.beforeClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
            close: _vm.closeDrawer,
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  display: "flex",
                  "align-items": "center",
                },
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.drawer = false
                      },
                    },
                  },
                  [_vm._v("关闭")]
                ),
                _c("div", [_vm._v("设备资料详情")]),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%", "overflow-x": "hidden" },
            },
            [
              _c(
                "el-card",
                {
                  staticStyle: {
                    height: "calc(100vh - 60px)",
                    "overflow-y": "auto",
                    "overflow-x": "hidden",
                    width: "100%",
                    position: "relative",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "100%", display: "flex" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { width: "calc(100% - 200px)" },
                          attrs: { id: "Device" },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "100%" } },
                            [
                              _c("div", { staticClass: "title" }, [
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "20px" } },
                                  [_vm._v("设备清单")]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "form",
                                  staticStyle: { "margin-bottom": "10px" },
                                },
                                [
                                  _c(
                                    "el-form",
                                    {
                                      ref: "form",
                                      attrs: {
                                        model: _vm.DataInfo.Base_Project,
                                        "label-width": "100px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: {
                                            "border-bottom": "1px solid #ccc",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "项目名称：",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.DataInfo?.Base_Project
                                                        ?.ProjectName
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "文件编号：",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.DataInfo?.Base_Project
                                                        ?.DocumentNumber
                                                    ) + " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: {
                                            "border-bottom": "1px solid #ccc",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "设备名称：",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.DataInfo
                                                          ?.Base_Project
                                                          ?.DeviceName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "联系人：" },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.DataInfo
                                                          ?.Base_Project
                                                          ?.Manager
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: {
                                            "border-bottom": "1px solid #ccc",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                { attrs: { label: "日期：" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.DataInfo
                                                          ?.Base_Project
                                                          ?.DocumentDate
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "联系电话：",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.DataInfo
                                                          ?.Base_Project
                                                          ?.ManagerPhone
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-bottom": "10px",
                                    "font-size": "14px",
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        width: "calc(100% / 3)",
                                        "margin-bottom": "10px",
                                        "padding-left": "10px",
                                        "padding-right": "10px",
                                        "box-sizing": "border-box",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { width: "130px" } },
                                        [
                                          _c(
                                            "span",
                                            { staticStyle: { color: "red" } },
                                            [_vm._v("*")]
                                          ),
                                          _vm._v(" 安装位置： "),
                                        ]
                                      ),
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: {
                                            width: "calc(100% - 130px)",
                                          },
                                          attrs: {
                                            placeholder: "未选择",
                                            disabled: _vm.disabled,
                                            size: "mini",
                                            filterable: "",
                                            clearable: "",
                                          },
                                          on: {
                                            change: _vm.changeInstallationArea,
                                          },
                                          model: {
                                            value:
                                              _vm.DataInfo.InstallationArea,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.DataInfo,
                                                "InstallationArea",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "DataInfo.InstallationArea",
                                          },
                                        },
                                        _vm._l(
                                          _vm.InstallationAreaData,
                                          function (val) {
                                            return _c("el-option", {
                                              key: val.Id,
                                              attrs: {
                                                label: val.DicName,
                                                value: val.Id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.InstallationAreaValue === "Indoor"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            width: "calc(100% / 3)",
                                            "margin-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "box-sizing": "border-box",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { width: "130px" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v("楼栋： "),
                                            ]
                                          ),
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                width: "calc(100% - 130px)",
                                              },
                                              attrs: {
                                                placeholder: "未选择",
                                                disabled: _vm.disabled,
                                                size: "mini",
                                                filterable: "",
                                                clearable: "",
                                              },
                                              on: {
                                                change: _vm.changeBuilding,
                                              },
                                              model: {
                                                value: _vm.DataInfo.BuildingId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.DataInfo,
                                                    "BuildingId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "DataInfo.BuildingId",
                                              },
                                            },
                                            _vm._l(
                                              _vm.BuildingData,
                                              function (val) {
                                                return _c("el-option", {
                                                  key: val.Id,
                                                  attrs: {
                                                    label: `${
                                                      val.BuildingCode
                                                        ? "【" +
                                                          val.BuildingCode +
                                                          "】"
                                                        : ""
                                                    }${val.BuildingName || ""}`,
                                                    value: val.Id,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.InstallationAreaValue === "Indoor" &&
                                  _vm.DataInfo.BuildingId != "其他"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            width: "calc(100% / 3)",
                                            "margin-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "box-sizing": "border-box",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { width: "120px" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v("楼层： "),
                                            ]
                                          ),
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                width: "calc(100% - 130px)",
                                              },
                                              attrs: {
                                                placeholder: "未选择",
                                                filterable: "",
                                                disabled: _vm.disabled,
                                                clearable: "",
                                                size: "mini",
                                              },
                                              model: {
                                                value:
                                                  _vm.DataInfo.BuildingFloor,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.DataInfo,
                                                    "BuildingFloor",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "DataInfo.BuildingFloor",
                                              },
                                            },
                                            _vm._l(
                                              _vm.BuildingFloorList,
                                              function (val, index) {
                                                return _c("el-option", {
                                                  key: val + index,
                                                  attrs: {
                                                    label: val,
                                                    value: val,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "el-collapse",
                                {
                                  model: {
                                    value: _vm.collapseValue,
                                    callback: function ($$v) {
                                      _vm.collapseValue = $$v
                                    },
                                    expression: "collapseValue",
                                  },
                                },
                                _vm._l(_vm.TabData, function (ele, index) {
                                  return _c(
                                    "el-collapse-item",
                                    {
                                      key: ele.DicValue,
                                      attrs: {
                                        name: ele.DicValue,
                                        id: ele.DicValue,
                                      },
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "calc(100% - 50px)",
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  width: "calc(100% - 130px)",
                                                  "font-weight": "bold",
                                                  "font-size": "18px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(index + 1) +
                                                    ". " +
                                                    _vm._s(ele.DicName) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("div", {
                                        staticStyle: {
                                          width: "100%",
                                          "border-top": "1px solid #ebeef5",
                                          "margin-bottom": "5px",
                                        },
                                      }),
                                      ele.DicValue !== "DocumentInformation"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-align": "right",
                                                "margin-bottom": "10px",
                                              },
                                            },
                                            [
                                              !_vm.disabled
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.saveData(
                                                            ele.DicValue,
                                                            ele.DicName
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("保存")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      ele.DicValue !== "DocumentInformation" &&
                                      ele.DicValue !==
                                        "SparePartsInformation" &&
                                      ele.DicValue !== "Device_Components"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                width: "100%",
                                                "flex-wrap": "wrap",
                                              },
                                            },
                                            [
                                              _vm._l(
                                                _vm.TemplateData[ele.DicValue],
                                                function (item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: item.FiledKey,
                                                      style: `width:${
                                                        100 / item.width
                                                      }%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;`,
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            width: "100%",
                                                            "font-size": "14px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                                width: "130px",
                                                                "align-items":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              item.IsEnable ||
                                                              item.disabled
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "red",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "*"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.FieldName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          item.ComponentType ===
                                                          "InputText"
                                                            ? _c("el-input", {
                                                                staticStyle: {
                                                                  width:
                                                                    "calc(100% - 130px)",
                                                                },
                                                                attrs: {
                                                                  placeholder:
                                                                    "未输入内容",
                                                                  type: "textarea",
                                                                  rows:
                                                                    item.rows ||
                                                                    1,
                                                                  resize:
                                                                    "none",
                                                                  disabled:
                                                                    _vm.disabled,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .DataInfo[
                                                                      ele
                                                                        .DicValue
                                                                    ][
                                                                      item
                                                                        .FiledKey
                                                                    ],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .DataInfo[
                                                                          ele
                                                                            .DicValue
                                                                        ],
                                                                        item.FiledKey,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "DataInfo[ele.DicValue][item.FiledKey]",
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          item.ComponentType ===
                                                          "InputNumber"
                                                            ? _c("el-input", {
                                                                staticStyle: {
                                                                  width:
                                                                    "calc(100% - 130px)",
                                                                },
                                                                attrs: {
                                                                  placeholder:
                                                                    "未输入内容",
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.disabled,
                                                                  resize:
                                                                    "none",
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .DataInfo[
                                                                      ele
                                                                        .DicValue
                                                                    ][
                                                                      item
                                                                        .FiledKey
                                                                    ],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .DataInfo[
                                                                          ele
                                                                            .DicValue
                                                                        ],
                                                                        item.FiledKey,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "DataInfo[ele.DicValue][item.FiledKey]",
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          item.ComponentType ===
                                                            "DatePicker" &&
                                                          _vm.DataInfo[
                                                            ele.DicValue
                                                          ]
                                                            ? _c(
                                                                "el-date-picker",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "calc(100% - 130px)",
                                                                  },
                                                                  attrs: {
                                                                    type: "date",
                                                                    placeholder:
                                                                      "选择日期",
                                                                    size: "mini",
                                                                    disabled:
                                                                      _vm.disabled,
                                                                    "value-format":
                                                                      "yyyy-MM-dd",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .DataInfo[
                                                                        ele
                                                                          .DicValue
                                                                      ][
                                                                        item
                                                                          .FiledKey
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .DataInfo[
                                                                            ele
                                                                              .DicValue
                                                                          ],
                                                                          item.FiledKey,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "DataInfo[ele.DicValue][item.FiledKey]",
                                                                  },
                                                                }
                                                              )
                                                            : _vm._e(),
                                                          item.ComponentType ===
                                                          "Radio"
                                                            ? _c(
                                                                "el-radio-group",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "calc(100% - 130px)",
                                                                    display:
                                                                      "flex",
                                                                    "align-items":
                                                                      "center",
                                                                  },
                                                                  attrs: {
                                                                    size: "mini",
                                                                    disabled:
                                                                      _vm.disabled,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .DataInfo[
                                                                        ele
                                                                          .DicValue
                                                                      ][
                                                                        item
                                                                          .FiledKey
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .DataInfo[
                                                                            ele
                                                                              .DicValue
                                                                          ],
                                                                          item.FiledKey,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "DataInfo[ele.DicValue][item.FiledKey]",
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  item.Source
                                                                    ? JSON.parse(
                                                                        item.Source
                                                                      )
                                                                    : [],
                                                                  function (
                                                                    val
                                                                  ) {
                                                                    return _c(
                                                                      "el-radio",
                                                                      {
                                                                        key: val.value,
                                                                        attrs: {
                                                                          label:
                                                                            val.value,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              val.value
                                                                            )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          item.ComponentType ===
                                                          "Select"
                                                            ? _c(
                                                                "el-select",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "calc(100% - 130px)",
                                                                  },
                                                                  attrs: {
                                                                    placeholder:
                                                                      "未选择",
                                                                    disabled:
                                                                      _vm.disabled,
                                                                    size: "mini",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .DataInfo[
                                                                        ele
                                                                          .DicValue
                                                                      ][
                                                                        item
                                                                          .FiledKey
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .DataInfo[
                                                                            ele
                                                                              .DicValue
                                                                          ],
                                                                          item.FiledKey,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "DataInfo[ele.DicValue][item.FiledKey]",
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  item.Source
                                                                    ? JSON.parse(
                                                                        item.Source
                                                                      )
                                                                    : [],
                                                                  function (
                                                                    val
                                                                  ) {
                                                                    return _c(
                                                                      "el-option",
                                                                      {
                                                                        key: val.value,
                                                                        attrs: {
                                                                          label:
                                                                            val.value,
                                                                          value:
                                                                            val.value,
                                                                        },
                                                                      }
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm.approvalComments[ele.DicValue]
                                                ? _c(
                                                    "div",
                                                    {
                                                      style: `width:100%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;`,
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            width: "100%",
                                                            "font-size": "14px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                                width: "130px",
                                                                "align-items":
                                                                  "center",
                                                                "font-weight":
                                                                  "bold",
                                                              },
                                                            },
                                                            [_vm._v("审核意见")]
                                                          ),
                                                          _c("el-input", {
                                                            staticStyle: {
                                                              width:
                                                                "calc(100% - 130px)",
                                                            },
                                                            attrs: {
                                                              placeholder:
                                                                "未输入内容",
                                                              disabled: !(
                                                                _vm.Status ==
                                                                  1 &&
                                                                !_vm.TwoToExamineUserId
                                                              ),
                                                              type: "textarea",
                                                              rows: 2,
                                                              resize: "none",
                                                              size: "mini",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .approvalComments[
                                                                  ele.DicValue
                                                                ].content,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .approvalComments[
                                                                      ele
                                                                        .DicValue
                                                                    ],
                                                                    "content",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "approvalComments[ele.DicValue].content",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      ele.DicValue === "Device_Components"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-collapse",
                                                {
                                                  attrs: {
                                                    value: _vm.TemplateData[
                                                      ele.DicValue
                                                    ].map(
                                                      (item) =>
                                                        item.ComponentDeviceType
                                                    ),
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.TemplateData[
                                                    ele.DicValue
                                                  ],
                                                  function (item) {
                                                    return _c(
                                                      "el-collapse-item",
                                                      {
                                                        key: item.FiledKey,
                                                        attrs: {
                                                          title:
                                                            item.ComponentDeviceTypeName,
                                                          name: item.ComponentDeviceType,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "title" },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  width:
                                                                    "calc(100% - 50px)",
                                                                  display:
                                                                    "flex",
                                                                  "align-items":
                                                                    "center",
                                                                  "justify-content":
                                                                    "space-between",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-weight":
                                                                          "bold",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.ComponentDeviceTypeName
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                                !_vm.disabled
                                                                  ? _c(
                                                                      "div",
                                                                      [
                                                                        _c(
                                                                          "el-button",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                type: "primary",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.AddComponentDeviceData(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "添加" +
                                                                                _vm._s(
                                                                                  item.ComponentDeviceTypeName
                                                                                ) +
                                                                                "信息"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-table",
                                                          {
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              data: _vm.DataInfo[
                                                                ele.DicValue
                                                              ].filter(
                                                                (val) =>
                                                                  val.DeviceType ===
                                                                  item.ComponentDeviceType
                                                              ),
                                                              size: "mini",
                                                              "max-height":
                                                                "400px",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "部件编号",
                                                                  prop: "device_no",
                                                                  align:
                                                                    "center",
                                                                  sortable: "",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "部件名称",
                                                                  prop: "device_name",
                                                                  align:
                                                                    "center",
                                                                  sortable: "",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "部件规格",
                                                                  prop: "specification",
                                                                  align:
                                                                    "center",
                                                                  sortable: "",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "部件数量",
                                                                  prop: "Num",
                                                                  align:
                                                                    "center",
                                                                  sortable: "",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "op",
                                                                  label: "操作",
                                                                  width:
                                                                    "100px",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function (
                                                                          scope
                                                                        ) {
                                                                          return [
                                                                            _c(
                                                                              "el-button",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    type: "text",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      $event.stopPropagation()
                                                                                      return _vm.EditComponentDeviceData(
                                                                                        scope.row
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "详情"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                              _vm.approvalComments[ele.DicValue]
                                                ? _c(
                                                    "div",
                                                    {
                                                      style: `width:100%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;`,
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            width: "100%",
                                                            "font-size": "14px",
                                                            "margin-top":
                                                              "10px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                                width: "130px",
                                                                "align-items":
                                                                  "center",
                                                                "font-weight":
                                                                  "bold",
                                                              },
                                                            },
                                                            [_vm._v("审核意见")]
                                                          ),
                                                          _c("el-input", {
                                                            staticStyle: {
                                                              width:
                                                                "calc(100% - 130px)",
                                                            },
                                                            attrs: {
                                                              placeholder:
                                                                "未输入内容",
                                                              disabled: !(
                                                                _vm.Status ==
                                                                  1 &&
                                                                !_vm.TwoToExamineUserId
                                                              ),
                                                              type: "textarea",
                                                              rows: 2,
                                                              resize: "none",
                                                              size: "mini",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .approvalComments[
                                                                  ele.DicValue
                                                                ].content,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .approvalComments[
                                                                      ele
                                                                        .DicValue
                                                                    ],
                                                                    "content",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "approvalComments[ele.DicValue].content",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      ele.DicValue === "SparePartsInformation"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-table",
                                                {
                                                  attrs: {
                                                    data: _vm.DataInfo[
                                                      ele.DicValue
                                                    ],
                                                    size: "mini",
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.TemplateData[
                                                      ele.DicValue
                                                    ],
                                                    function (tableItem) {
                                                      return _c(
                                                        "el-table-column",
                                                        {
                                                          key: tableItem.FiledKey,
                                                          attrs: {
                                                            label:
                                                              tableItem.FieldName,
                                                            prop: tableItem.FiledKey,
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function (
                                                                  scope
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "el-input",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100%",
                                                                          },
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.disabled,
                                                                          placeholder:
                                                                            "请输入",
                                                                          type:
                                                                            tableItem.ComponentType ===
                                                                            "InputText"
                                                                              ? "text"
                                                                              : "number",
                                                                          resize:
                                                                            "none",
                                                                          size: "mini",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            scope
                                                                              .row[
                                                                              tableItem
                                                                                .FiledKey
                                                                            ],
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                scope.row,
                                                                                tableItem.FiledKey,
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "scope.row[tableItem.FiledKey]",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        }
                                                      )
                                                    }
                                                  ),
                                                  !_vm.disabled
                                                    ? _c("el-table-column", {
                                                        attrs: {
                                                          label: "操作",
                                                          width: "100px",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function (
                                                                scope
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        type: "text",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.TableDeleteRow(
                                                                              scope.$index,
                                                                              ele.DicValue
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "删除"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      })
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                              !_vm.disabled
                                                ? _c("el-button", {
                                                    staticStyle: {
                                                      "font-size": "14px",
                                                    },
                                                    attrs: {
                                                      icon: "el-icon-plus",
                                                      circle: "",
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.TableAddRow(
                                                          ele.DicValue
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm.approvalComments[ele.DicValue]
                                                ? _c(
                                                    "div",
                                                    {
                                                      style: `width:100%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;`,
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            width: "100%",
                                                            "font-size": "14px",
                                                            "margin-top":
                                                              "10px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                                width: "130px",
                                                                "align-items":
                                                                  "center",
                                                                "font-weight":
                                                                  "bold",
                                                              },
                                                            },
                                                            [_vm._v("审核意见")]
                                                          ),
                                                          _c("el-input", {
                                                            staticStyle: {
                                                              width:
                                                                "calc(100% - 130px)",
                                                            },
                                                            attrs: {
                                                              placeholder:
                                                                "未输入内容",
                                                              disabled: !(
                                                                _vm.Status ==
                                                                  1 &&
                                                                !_vm.TwoToExamineUserId
                                                              ),
                                                              type: "textarea",
                                                              rows: 2,
                                                              resize: "none",
                                                              size: "mini",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .approvalComments[
                                                                  ele.DicValue
                                                                ].content,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .approvalComments[
                                                                      ele
                                                                        .DicValue
                                                                    ],
                                                                    "content",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "approvalComments[ele.DicValue].content",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      ele.DicValue === "DocumentInformation"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                width: "100%",
                                                "flex-wrap": "wrap",
                                                position: "relative",
                                              },
                                            },
                                            [
                                              !_vm.disabled
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                        "background-color":
                                                          "#fff",
                                                        padding: "10px",
                                                        "border-radius": "5px",
                                                        "text-align": "right",
                                                        position: "sticky",
                                                        top: "0",
                                                        right: "0",
                                                        "z-index": "99",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.DocumentSubmit(
                                                                ele
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("提交文档")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._l(
                                                _vm.TemplateData[ele.DicValue],
                                                function (item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: item.FiledKey,
                                                      style: `width:${
                                                        100 / item.width
                                                      }%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;`,
                                                    },
                                                    [
                                                      _c(
                                                        "el-table",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            size: "mini",
                                                            data: item.device_TypeTwoDocuments.filter(
                                                              (vall) =>
                                                                item.cList.includes(
                                                                  vall.Type
                                                                )
                                                            ),
                                                            "header-row-class-name":
                                                              "header-class",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                type: "index",
                                                                label: "序号",
                                                                width: "50",
                                                                align: "center",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop: "TypeName",
                                                                label:
                                                                  item.FieldName,
                                                                resizable: false,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "default",
                                                                      fn: function (
                                                                        scope
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              scope
                                                                                .row
                                                                                .disabled
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticStyle:
                                                                                        {
                                                                                          color:
                                                                                            "red",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "*"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    `${scope.row.TypeName}`
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          scope
                                                                            .row
                                                                            .Remark
                                                                            ? _c(
                                                                                "el-popover",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      placement:
                                                                                        "bottom-start",
                                                                                      "open-delay": 100,
                                                                                      width:
                                                                                        "200",
                                                                                      trigger:
                                                                                        "hover",
                                                                                      content:
                                                                                        scope
                                                                                          .row
                                                                                          .Remark,
                                                                                      "popper-class":
                                                                                        "table-popper",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "i",
                                                                                    {
                                                                                      staticClass:
                                                                                        "el-icon-question",
                                                                                      attrs:
                                                                                        {
                                                                                          slot: "reference",
                                                                                        },
                                                                                      slot: "reference",
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            }
                                                          ),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop: "Type",
                                                                label:
                                                                  "文件信息",
                                                                resizable: false,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "default",
                                                                      fn: function (
                                                                        scope
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "el-upload",
                                                                            {
                                                                              ref:
                                                                                "upload_" +
                                                                                scope
                                                                                  .row
                                                                                  .Type,
                                                                              refInFor: true,
                                                                              staticClass:
                                                                                "upload-demo",
                                                                              attrs:
                                                                                {
                                                                                  limit: 9,
                                                                                  action:
                                                                                    _vm.$rootUrl +
                                                                                    `/Base_Manage/Upload/ProjectOssUploadFileByForm?ProjectId=${_vm.ProjectId}&UserId=${_vm.SupplierId}&type=3&SupplierId=${_vm.SupplierId}&DeviceType=${_vm.treeId}`,
                                                                                  multiple:
                                                                                    "",
                                                                                  disabled:
                                                                                    scope
                                                                                      .row
                                                                                      .IsUpStatus ||
                                                                                    _vm.disabled,
                                                                                  headers:
                                                                                    {
                                                                                      Authorization:
                                                                                        "Bearer " +
                                                                                        _vm.TokenCache.getToken(),
                                                                                    },
                                                                                  "before-remove":
                                                                                    (
                                                                                      file
                                                                                    ) =>
                                                                                      _vm.beforeRemove(
                                                                                        file,
                                                                                        item
                                                                                      ),
                                                                                  "file-list":
                                                                                    _vm
                                                                                      .DataInfo[
                                                                                      ele
                                                                                        .DicValue
                                                                                    ][
                                                                                      scope
                                                                                        .row
                                                                                        .Type +
                                                                                        "List"
                                                                                    ],
                                                                                  "on-exceed":
                                                                                    _vm.handleExceed,
                                                                                  "on-preview":
                                                                                    _vm.handlePreview,
                                                                                  "on-change":
                                                                                    (
                                                                                      file,
                                                                                      fileList
                                                                                    ) =>
                                                                                      _vm.handleChange(
                                                                                        file,
                                                                                        fileList,
                                                                                        scope
                                                                                          .row
                                                                                          .Type
                                                                                      ),
                                                                                  "on-success":
                                                                                    (
                                                                                      response,
                                                                                      file,
                                                                                      fileList
                                                                                    ) =>
                                                                                      _vm.handleSuccess(
                                                                                        response,
                                                                                        file,
                                                                                        fileList,
                                                                                        scope.row
                                                                                      ),
                                                                                  "on-error":
                                                                                    (
                                                                                      err,
                                                                                      file,
                                                                                      fileList
                                                                                    ) =>
                                                                                      _vm.handleError(
                                                                                        err,
                                                                                        file,
                                                                                        fileList,
                                                                                        scope.row
                                                                                      ),
                                                                                  "on-remove":
                                                                                    (
                                                                                      file,
                                                                                      fileList
                                                                                    ) =>
                                                                                      _vm.handleRemove(
                                                                                        file,
                                                                                        fileList,
                                                                                        scope.row
                                                                                      ),
                                                                                  "auto-upload": true,
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                [
                                                                                  !_vm.disabled
                                                                                    ? _c(
                                                                                        "el-button",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              size: "mini",
                                                                                              type: "primary",
                                                                                              disabled:
                                                                                                !_vm.DeviceId ||
                                                                                                _vm.disabled,
                                                                                              loading:
                                                                                                scope
                                                                                                  .row
                                                                                                  .IsUpStatus,
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              scope
                                                                                                .row
                                                                                                .IsUpStatus
                                                                                                ? "上传中"
                                                                                                : "选择文件"
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            }
                                                          ),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop: "TypeName",
                                                                label:
                                                                  "文件大小",
                                                                resizable: false,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "default",
                                                                      fn: function (
                                                                        scope
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  "margin-top":
                                                                                    "10px",
                                                                                },
                                                                            },
                                                                            _vm._l(
                                                                              _vm
                                                                                .DataInfo[
                                                                                ele
                                                                                  .DicValue
                                                                              ][
                                                                                scope
                                                                                  .row
                                                                                  .Type +
                                                                                  "List"
                                                                              ],
                                                                              function (
                                                                                item
                                                                              ) {
                                                                                return _c(
                                                                                  "div",
                                                                                  {
                                                                                    key: item.uid,
                                                                                    staticStyle:
                                                                                      {
                                                                                        width:
                                                                                          "100%",
                                                                                        "line-height":
                                                                                          "1.8",
                                                                                        "margin-top":
                                                                                          "5px",
                                                                                        "font-size":
                                                                                          "14px",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            width:
                                                                                              "120px",
                                                                                            display:
                                                                                              "flex",
                                                                                            "align-items":
                                                                                              "center",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          " " +
                                                                                            _vm._s(
                                                                                              _vm.setSize(
                                                                                                item.size
                                                                                              )
                                                                                            ) +
                                                                                            " "
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            }
                                                          ),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "上传状态",
                                                                width: "100",
                                                                align: "center",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "default",
                                                                      fn: function (
                                                                        scope
                                                                      ) {
                                                                        return [
                                                                          _vm
                                                                            .DataInfo[
                                                                            ele
                                                                              .DicValue
                                                                          ][
                                                                            scope
                                                                              .row
                                                                              .Type +
                                                                              "List"
                                                                          ]
                                                                            ?.length >
                                                                            0 &&
                                                                          _vm.DataInfo[
                                                                            ele
                                                                              .DicValue
                                                                          ][
                                                                            scope
                                                                              .row
                                                                              .Type +
                                                                              "List"
                                                                          ]?.every(
                                                                            (
                                                                              item
                                                                            ) =>
                                                                              item.status ===
                                                                              "success"
                                                                          )
                                                                            ? _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "el-icon-circle-check",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-size":
                                                                                        "20px",
                                                                                      color:
                                                                                        "#67c23a",
                                                                                    },
                                                                                }
                                                                              )
                                                                            : _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "el-icon-circle-close",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-size":
                                                                                        "20px",
                                                                                      color:
                                                                                        "#f56c6c",
                                                                                    },
                                                                                }
                                                                              ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _vm.approvalComments[ele.DicValue]
                                                ? _c(
                                                    "div",
                                                    {
                                                      style: `width:100%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;`,
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            width: "100%",
                                                            "font-size": "14px",
                                                            "margin-top":
                                                              "10px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                                width: "130px",
                                                                "align-items":
                                                                  "center",
                                                                "font-weight":
                                                                  "bold",
                                                              },
                                                            },
                                                            [_vm._v("审核意见")]
                                                          ),
                                                          _c("el-input", {
                                                            staticStyle: {
                                                              width:
                                                                "calc(100% - 130px)",
                                                            },
                                                            attrs: {
                                                              placeholder:
                                                                "未输入内容",
                                                              disabled: !(
                                                                _vm.Status ==
                                                                  1 &&
                                                                !_vm.TwoToExamineUserId
                                                              ),
                                                              type: "textarea",
                                                              rows: 2,
                                                              resize: "none",
                                                              size: "mini",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .approvalComments[
                                                                  ele.DicValue
                                                                ].content,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .approvalComments[
                                                                      ele
                                                                        .DicValue
                                                                    ],
                                                                    "content",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "approvalComments[ele.DicValue].content",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                }),
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form",
                                  staticStyle: { "margin-top": "10px" },
                                },
                                [
                                  _c(
                                    "el-form",
                                    {
                                      ref: "form",
                                      attrs: {
                                        model: _vm.DataInfo.Base_Project,
                                        "label-width": "100px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                { attrs: { label: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                        "font-size": "16px",
                                                      },
                                                      attrs: { slot: "label" },
                                                      slot: "label",
                                                    },
                                                    [_vm._v(" 业主： ")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                { attrs: { label: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                        "font-size": "16px",
                                                      },
                                                      attrs: { slot: "label" },
                                                      slot: "label",
                                                    },
                                                    [_vm._v(" 顾问公司： ")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                { attrs: { label: "姓名：" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.DataInfo?.Base_Project
                                                        ?.TwoToExamineUserId
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                { attrs: { label: "姓名：" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.DataInfo?.Base_Project
                                                        ?.OneToExamineUserId
                                                    ) + " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                { attrs: { label: "签名：" } },
                                                [
                                                  _vm.DataInfo?.Base_Project
                                                    ?.TwoToExamineUserSign
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "align-items":
                                                              "center",
                                                            "justify-content":
                                                              "center",
                                                            "text-align":
                                                              "center",
                                                            "box-sizing":
                                                              "border-box",
                                                            overflow: "hidden",
                                                            width: "200px",
                                                            height: "100px",
                                                          },
                                                        },
                                                        [
                                                          _c("el-image", {
                                                            staticStyle: {
                                                              width: "100%",
                                                              height: "100%",
                                                              background:
                                                                "#fff",
                                                              "box-sizing":
                                                                "border-box",
                                                            },
                                                            attrs: {
                                                              src: _vm.DataInfo
                                                                ?.Base_Project
                                                                ?.TwoToExamineUserSign,
                                                              alt: "",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                { attrs: { label: "签名：" } },
                                                [
                                                  _vm.DataInfo?.Base_Project
                                                    ?.OneToExamineUserSign
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "align-items":
                                                              "center",
                                                            "justify-content":
                                                              "center",
                                                            "text-align":
                                                              "center",
                                                            "box-sizing":
                                                              "border-box",
                                                            overflow: "hidden",
                                                            width: "200px",
                                                            height: "100px",
                                                          },
                                                        },
                                                        [
                                                          _c("el-image", {
                                                            staticStyle: {
                                                              width: "100%",
                                                              height: "100%",
                                                              background:
                                                                "#fff",
                                                              "box-sizing":
                                                                "border-box",
                                                            },
                                                            attrs: {
                                                              src: _vm.DataInfo
                                                                ?.Base_Project
                                                                ?.OneToExamineUserSign,
                                                              alt: "",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                { attrs: { label: "日期：" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.DataInfo
                                                          ?.Base_Project
                                                          ?.TwoToExamineTime
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                { attrs: { label: "日期：" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.DataInfo
                                                          ?.Base_Project
                                                          ?.OneToExamineTime
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: { "margin-top": "30px" },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "提交人：" },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.row
                                                          .SubmitUserName || ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "提交日期：",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.row.SubmitTime
                                                          ? _vm
                                                              .moment(
                                                                _vm.row
                                                                  .SubmitTime
                                                              )
                                                              .format(
                                                                "YYYY-MM-DD"
                                                              )
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "steps-box",
                          staticStyle: {
                            width: "180px",
                            height: "calc(100vh - 150px)",
                            position: "fixed",
                            right: "40px",
                            top: "100px",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { height: "100%" } },
                            _vm._l(_vm.TabData, function (ele, index) {
                              return _c(
                                "div",
                                {
                                  key: ele.DicValue,
                                  style: `height: calc(100% / ${_vm.TabData.length});`,
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        height: "100%",
                                        display: "flex",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "steps-left" }, [
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              "steps",
                                              _vm.DataInfo[
                                                ele.DicValue + "Status"
                                              ] == 1
                                                ? "steps-success"
                                                : "",
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.anchorClick(
                                                  ele.DicValue,
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.DataInfo[
                                              ele.DicValue + "Status"
                                            ] == 1
                                              ? _c("i", {
                                                  staticClass: "el-icon-check",
                                                })
                                              : _c("span", [
                                                  _vm._v(_vm._s(index + 1)),
                                                ]),
                                          ]
                                        ),
                                        index != _vm.TabData.length - 1
                                          ? _c("div", {
                                              class: [
                                                "steps-left-line",
                                                _vm.DataInfo[
                                                  ele.DicValue + "Status"
                                                ] == 1
                                                  ? "steps-success-line"
                                                  : "",
                                              ],
                                            })
                                          : _vm._e(),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "steps-right" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "steps-right-title",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    _vm.DataInfo[
                                                      ele.DicValue + "Status"
                                                    ] == 1
                                                      ? "steps-success"
                                                      : "",
                                                  ],
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.anchorClick(
                                                        ele.DicValue,
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(index + 1) +
                                                      "." +
                                                      _vm._s(ele.DicName)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    height: "40px",
                    width: "300px",
                    position: "fixed",
                    bottom: "0",
                    right: "0",
                    "z-index": "8888",
                    "text-align": "right",
                  },
                },
                [
                  _vm.Status == 1 && !_vm.TwoToExamineUserId
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "success", loading: _vm.loading },
                          on: {
                            click: function ($event) {
                              return _vm.handleAutd(3, "通过")
                            },
                          },
                        },
                        [_vm._v("通过")]
                      )
                    : _vm._e(),
                  _vm.Status == 1 && !_vm.TwoToExamineUserId
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "30px" },
                          attrs: { type: "danger", loading: _vm.loading },
                          on: {
                            click: function ($event) {
                              return _vm.handleAutd(4, "驳回")
                            },
                          },
                        },
                        [_vm._v("驳回")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请输入驳回原因",
            visible: _vm.rejectVisible,
            width: "400px",
            top: "20vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rejectVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: { type: "textarea", rows: 9, placeholder: "请输入内容" },
            model: {
              value: _vm.rejectText,
              callback: function ($$v) {
                _vm.rejectText = $$v
              },
              expression: "rejectText",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rejectVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.rejectYes } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批注",
            visible: _vm.approvalDialogVisible,
            width: "500px",
            top: "15vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approvalDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "approval-dialog-content" },
            [
              _c("div", { staticClass: "step-info" }, [
                _c("span", { staticClass: "step-name" }, [
                  _vm._v(_vm._s(_vm.currentStepName)),
                ]),
              ]),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 8,
                  placeholder: "请输入批注",
                  maxlength: "500",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.approvalComment,
                  callback: function ($$v) {
                    _vm.approvalComment = $$v
                  },
                  expression: "approvalComment",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.approvalDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveApprovalComment },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("TemplateFormInfoAssembly", { ref: "TemplateFormInfoAssembly" }),
      _c("SignDialog", { ref: "SignDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }